import { AuthService } from './auth.service';
import { getDomainFromUrl } from '@account-users/utils';
import { Inject, Injectable } from '@angular/core';

@Injectable()
export class JwtTokenFactory {
  constructor(
    private authService: AuthService,
    @Inject('apiBaseUrl') private readonly apiBaseUrl: string,
    @Inject('emailBaseUrl') private readonly emailBaseUrl: string,
    @Inject('maBaseUrl') private readonly maBaseUrl: string,
    @Inject('ecomBaseUrl') private readonly ecomBaseUrl: string,
    @Inject('smsBaseUrl') private readonly smsBaseUrl: string,
    @Inject('privateDomainUrl') private readonly privateDomainUrl: string,
  ) {}

  public whitelistedDomains: string[] = [
    getDomainFromUrl(this.apiBaseUrl),
    getDomainFromUrl(this.emailBaseUrl),
    getDomainFromUrl(this.maBaseUrl),
    getDomainFromUrl(this.ecomBaseUrl),
    getDomainFromUrl(this.smsBaseUrl),
    getDomainFromUrl(this.privateDomainUrl),
  ];

  public tokenGetter = () => this.authService.accessToken;
}
